import React, { useMemo } from 'react';
import { Box, Image, Inscription, useCountryByNumber } from '@common-fe/common-fe';

import { ProfileSettingsOption } from '@/modules/user/components/ManageProfile/components/ProfileSettingCard/profileSettings.types';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

const useTextMessagesOptions = () => {
  const { employee } = useEmployeeStore();
  const { icon } = useCountryByNumber(employee?.preferredPhone?.number);

  const mobilePhone = employee?.phone?.number;

  const textMessagesOptions = useMemo(
    (): ProfileSettingsOption[] => [
      {
        key: 'mobilePhone',
        title: 'Mobile phone',
        isEditButton: true,
        value: mobilePhone && (
          <Box direction="row" align="center">
            <Image width="16px" height="16px" src={icon} />
            <Inscription margin={{ left: 'spacing4' }}>{mobilePhone}</Inscription>
          </Box>
        ),
        isActive: !!mobilePhone && employee?.isVerifiedPhoneNumber,
        isSelected: !!mobilePhone,
      },
    ],
    [mobilePhone, icon, employee]
  );

  return { textMessagesOptions };
};

export default useTextMessagesOptions;
